window.bundleProduct = () => {

    const selectors = {
        buttons: '[data-drawer-button]',
        container: '.bundle-products',
        wrapper: '.radio-button-wrapper',
        radioButton: '[radio-button-container]',
        backdrop: '.backdrop',
        closeButton: '.drawer__close',
        radioButtonsDrawer: '[data-radio-buttons]'
    }

    const container = document.querySelector(selectors.container);

    function init() {
        if (!container) {
            return;
        }
        bindEvents();
    }

    function bindEvents() {

        const buttons = container.querySelectorAll(selectors.buttons);
        buttons.forEach((button) => {
            button.addEventListener('click', handleClick)
        });

        const radioButtons = container.querySelectorAll(selectors.radioButton);
        radioButtons.forEach((radioButton) => {
            radioButton.addEventListener('click', handleRadioClick)
        });

        const backdrops = document.querySelectorAll(selectors.backdrop);
        backdrops.forEach((backdrop) => {
            backdrop.addEventListener('click', closeAll)
        });

        const drawerClose = container.querySelectorAll(selectors.closeButton);
        drawerClose.forEach((closeButton) => {
            closeButton.addEventListener('click', closeAll)
        });
    }

    function handleClick(e) {
        const button = e.target;
        if (!button.closest(selectors.wrapper).classList.contains('open')) {
            const buttons = container.querySelectorAll(selectors.buttons);
            buttons.forEach((button) => {
                button.closest(selectors.wrapper).classList.remove('open');
            });
            const drawer = button.closest(selectors.wrapper).querySelector(selectors.radioButtonsDrawer);
            let buttonHeight = e.currentTarget.offsetHeight;
            if (drawer) {
                drawer.style.top = `${buttonHeight - 4}px`;
            }
            button.closest(selectors.wrapper).classList.add('open');
            document.querySelector('#shopify-section-header').classList.add('shopify-section-header-hidden');
        } else {
            button.closest(selectors.wrapper).classList.remove('open');
        }
        document.body.classList.toggle('bundle-drawer-open');
    }

    function handleRadioClick(e) {
        const input = e.target;
        if (!input) return;

        if (this.dataset.disabled == "true") return;
        
        const label = input.closest('label');
        if (!label) return;

        const innerHtml = label.innerHTML;
        
        const radioButtonWrap = input.closest('[data-radio-buttons]');

        const radioButtonsContainerId = radioButtonWrap.dataset.forId;
        const radioButtonsContainer = document.getElementById(radioButtonsContainerId);
        if (!container) return;

        const button = radioButtonsContainer.querySelector('[data-drawer-button]')
        if (!button) return;
        button.innerHTML = innerHtml;

        if (button.querySelector('div')) {
            const title = button.querySelector('div').dataset.titleComplete;
            button.querySelector('div').textContent = title;
        }

        closeAll()
    }

    function closeAll() {
        const buttons = container.querySelectorAll(selectors.buttons);
        buttons.forEach((button) => {
            button.closest(selectors.wrapper).classList.remove('open');
        });
        document.body.classList.remove('bundle-drawer-open');
    }


    init();
}